import { __assign, __rest } from "tslib";
import { ItemType } from '../domain';
import { ArticleAlternativeContentNumber } from '../domain/kb/articles/article-alternative-content';
export var DEFAULT_PAGE = 1;
export var DEFAULT_PAGE_SIZE = 50;
var getArticleUri = function (baseUrl, articleId) { return "".concat(baseUrl, "/articles/").concat(articleId); };
export var createArticlesApi = function (baseUrl, http) {
    var articlesApi = {
        adminSearch: function (dto) {
            return http.post("".concat(baseUrl, "/articles/search/admin"), dto);
        },
        search: function (dto) {
            return http.post("".concat(baseUrl, "/articles/search"), dto);
        },
        helpcenterSearch: function (dto) {
            return http.post("".concat(baseUrl, "/helpcenter/articles/search"), dto);
        },
        getArticle: function (dto) {
            return http.get("".concat(getArticleUri(baseUrl, dto.id), "?locale=").concat(dto.locale));
        },
        getArticleAlternativeContent: function (dto) {
            return http.get("".concat(getArticleUri(baseUrl, dto.id), "/alternativeContent?locale=").concat(dto.locale, "&versionNumber=").concat(ArticleAlternativeContentNumber.VERSION_B));
        },
        getArticleByUri: function (dto) {
            return http.get("".concat(baseUrl, "/articles/uri/").concat(dto.uri, "?locale=").concat(dto.locale));
        },
        getExtendedArticle: function (dto) {
            return http.get("".concat(getArticleUri(baseUrl, dto.id), "/extended?locale=").concat(dto.locale));
        },
        getArticleTasks: function (dto) {
            return http.get("".concat(baseUrl, "/articles/").concat(dto.id, "/tasks?locale=").concat(dto.locale, "&page=").concat(dto.page || DEFAULT_PAGE, "&pageSize=").concat(dto.pageSize || DEFAULT_PAGE_SIZE));
        },
        getArticleTask: function (dto) {
            return http.get("".concat(baseUrl, "/articles/").concat(dto.id, "/tasks/").concat(dto.taskId, "?locale=").concat(dto.locale));
        },
        addArticle: function (dto) { return http.post("".concat(baseUrl, "/articles"), dto); },
        addArticleAlternativeContent: function (dto) { return http.post("".concat(getArticleUri(baseUrl, dto.id), "/alternativeContent"), dto); },
        endArticleAbTest: function (dto) { return http.post("".concat(getArticleUri(baseUrl, dto.id), "/alternativeContent/end"), dto); },
        saveArticle: function (dto) { return http.put(getArticleUri(baseUrl, dto.id), dto); },
        unpublishArticle: function (dto) { return http.post("".concat(getArticleUri(baseUrl, dto.id), "/unpublish"), dto); },
        deleteArticle: function (dto) { return http.delete("".concat(getArticleUri(baseUrl, dto.id), "?locale=").concat(dto.locale)); },
        saveAndPublishArticle: function (dto) { return http.post("".concat(getArticleUri(baseUrl, dto.id), "/publish"), dto); },
        getArticleListPresenceInfo: function (dto) {
            return http.post("".concat(baseUrl, "/articles/presence"), dto);
        },
        getArticlePresenceInfo: function (dto) {
            return http.get("".concat(getArticleUri(baseUrl, dto.id), "/presence?locale=").concat(dto.locale, "&maxAge=5"));
        },
        reportArticlePresence: function (dto) {
            return http.post("".concat(getArticleUri(baseUrl, dto.id), "/presence"), __assign(__assign({}, dto), { itemType: ItemType.ARTICLE }));
        },
        deleteArticlePresence: function (dto) {
            return http.delete("".concat(getArticleUri(baseUrl, dto.id), "/presence?locale=").concat(dto.locale, "&itemType=").concat(ItemType.ARTICLE));
        },
        getArticleCounters: function (dto) {
            return http.get("".concat(getArticleUri(baseUrl, dto.id), "/counters?locale=").concat(dto.locale));
        },
        moveArticleToCategory: function (dto) {
            var requestBody = {
                categoryId: dto.categoryId
            };
            return http.post("".concat(getArticleUri(baseUrl, dto.id), "/move"), requestBody);
        },
        getArticleActivityEvents: function (_a) {
            var locale = _a.locale, id = _a.id, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.pageSize, pageSize = _c === void 0 ? 200 : _c;
            // tslint:disable-next-line: max-line-length
            return http.get("".concat(baseUrl, "/history/item?itemId=").concat(id, "&locale=").concat(locale, "&itemType=").concat(ItemType.ARTICLE, "&page=").concat(page, "&pageSize=").concat(pageSize));
        },
        getRelatedArticles: function (dto) {
            return http.get("".concat(getArticleUri(baseUrl, dto.id), "/relations/admin?locale=").concat(dto.locale));
        },
        getHelpcenterTicketRelatedArticles: function (dto) {
            return http.get("".concat(baseUrl, "/tickets/").concat(dto.ticketId, "/relations?itemsCount=").concat(dto.itemsCount));
        },
        getHelpcenterRelatedArticles: function (dto) {
            return http.get("".concat(getArticleUri(baseUrl, dto.id), "/relations?locale=").concat(dto.locale));
        },
        addRelatedArticle: function (dto) {
            return http.post("".concat(getArticleUri(baseUrl, dto.id), "/relations"), {
                relatedId: dto.relatedId,
                doInAllLangs: dto.doInAllLangs || false,
                locale: dto.locale
            });
        },
        sortRelatedArticles: function (dto) {
            return http.post("".concat(getArticleUri(baseUrl, dto.id), "/relations/sort"), {
                relatedIds: dto.relatedIds,
                locale: dto.locale
            });
        },
        removeRelatedArticle: function (dto) {
            return http.delete("".concat(getArticleUri(baseUrl, dto.id), "/relations/").concat(dto.relatedId, "?locale=").concat(dto.locale).concat(dto.doInAllLangs ? "&doInAllLangs=".concat(dto.doInAllLangs) : ''));
        },
        updateLabels: function (dto) {
            return http.put("".concat(getArticleUri(baseUrl, dto.id), "/labels"), {
                locale: dto.locale,
                addedLabelIds: dto.addedLabelIds,
                removedLabelIds: dto.removedLabelIds
            });
        },
        updateArticleType: function (dto) {
            return http.post("".concat(getArticleUri(baseUrl, dto.id), "/changeType"), {
                type: dto.type
            });
        },
        updateArticleResolution: function (dto) {
            return http.post("".concat(getArticleUri(baseUrl, dto.id), "/setResolution"), {
                resolution: dto.resolution,
                notify: dto.notify,
                locales: dto.locales,
                resolutionEta: dto.resolutionEta,
                featureUrl: dto.featureUrl,
                featureEnrollment: dto.featureEnrollment,
                allowEnrollment: dto.allowEnrollment
            });
        },
        addTask: function (dto) {
            return http.post("".concat(getArticleUri(baseUrl, dto.id), "/tasks"), {
                locale: dto.locale,
                type: dto.type,
                priority: dto.priority,
                description: dto.description,
                assignedUserId: dto.assignedUserId
            });
        },
        updateTask: function (dto) {
            return http.put("".concat(getArticleUri(baseUrl, dto.id), "/tasks/").concat(dto.taskId), {
                locale: dto.locale,
                type: dto.type,
                priority: dto.priority,
                description: dto.description,
                assignedUserId: dto.assignedUserId,
                subType: dto.subType
            });
        },
        addTaskComment: function (dto) {
            var id = dto.id, taskId = dto.taskId, rest = __rest(dto, ["id", "taskId"]);
            return http.post("".concat(getArticleUri(baseUrl, id), "/tasks/").concat(taskId, "/notes"), rest);
        },
        completeTask: function (dto) {
            var id = dto.id, taskId = dto.taskId;
            return http.post("".concat(getArticleUri(baseUrl, id), "/tasks/").concat(taskId, "/complete"), {});
        },
        deleteTask: function (dto) {
            var id = dto.id, taskId = dto.taskId, locale = dto.locale;
            return http.delete("".concat(getArticleUri(baseUrl, id), "/tasks/").concat(taskId, "?locale=").concat(locale));
        },
        editTaskComment: function (dto) {
            var id = dto.id, taskId = dto.taskId, noteId = dto.noteId, rest = __rest(dto, ["id", "taskId", "noteId"]);
            return http.put("".concat(getArticleUri(baseUrl, id), "/tasks/").concat(taskId, "/notes/").concat(noteId), rest);
        },
        removeTaskComment: function (dto) {
            var id = dto.id, taskId = dto.taskId, noteId = dto.noteId, locale = dto.locale;
            return http.delete("".concat(getArticleUri(baseUrl, id), "/tasks/").concat(taskId, "/notes/").concat(noteId, "?locale=").concat(locale));
        },
        reopenTask: function (dto) {
            var id = dto.id, taskId = dto.taskId;
            return http.post("".concat(getArticleUri(baseUrl, id), "/tasks/").concat(taskId, "/open"), {});
        },
        getArticleNotes: function (dto) {
            var id = dto.id, locale = dto.locale;
            return http.get("".concat(getArticleUri(baseUrl, id), "/notes?locale=").concat(locale));
        },
        addArticleNote: function (dto) {
            var id = dto.id, rest = __rest(dto, ["id"]);
            return http.post("".concat(getArticleUri(baseUrl, id), "/notes"), rest);
        },
        deleteArticleNote: function (dto) {
            var id = dto.id, noteId = dto.noteId, locale = dto.locale;
            return http.delete("".concat(getArticleUri(baseUrl, id), "/notes/").concat(noteId, "?locale=").concat(locale));
        },
        updateArticleNote: function (dto) {
            var id = dto.id, noteId = dto.noteId, locale = dto.locale, content = dto.content;
            return http.put("".concat(getArticleUri(baseUrl, id), "/notes/").concat(noteId), { text: content, locale: locale });
        },
        updateArticleKeywords: function (dto) {
            var id = dto.id, locale = dto.locale, textValues = dto.textValues;
            return http.put("".concat(getArticleUri(baseUrl, id), "/phrases"), { textValues: textValues, locale: locale });
        },
        getArticleVersions: function (dto) {
            var id = dto.id, locale = dto.locale;
            return http.get("".concat(getArticleUri(baseUrl, id), "/versions?locale=").concat(locale)).then(function (versions) {
                return versions.map(function (version) {
                    if (version.lastUpdateDate > 1455746400000 && version.lastUpdateDate < 1455832799000) {
                        return __assign(__assign({}, version), { lastUpdateDate: version.creationDate });
                    }
                    return version;
                });
            });
        },
        addArticleComment: function (dto) {
            var id = dto.id, rest = __rest(dto, ["id"]);
            return http.post("".concat(getArticleUri(baseUrl, id), "/comments"), rest);
        },
        getArticleComments: function (dto) {
            var id = dto.id, locale = dto.locale;
            return http.get("".concat(getArticleUri(baseUrl, id), "/comments?locale=").concat(locale));
        },
        setArticleCommentResolved: function (dto) {
            var resolved = dto.resolved, commentId = dto.commentId, id = dto.id;
            return http.put("".concat(getArticleUri(baseUrl, id), "/comments/").concat(commentId, "/resolved"), { resolved: resolved });
        },
        setArticleCommentContent: function (dto) {
            var content = dto.content, commentId = dto.commentId, id = dto.id;
            return http.put("".concat(getArticleUri(baseUrl, id), "/comments/").concat(commentId), { content: content });
        },
        deleteArticleComment: function (dto) {
            var commentId = dto.commentId, id = dto.id;
            return http.delete("".concat(getArticleUri(baseUrl, id), "/comments/").concat(commentId));
        },
        addArticleCommentReply: function (dto) {
            var id = dto.id, commentId = dto.commentId, rest = __rest(dto, ["id", "commentId"]);
            return http.post("".concat(getArticleUri(baseUrl, id), "/comments/").concat(commentId, "/replies"), rest);
        },
        getArticleCommentReplies: function (dto) {
            var id = dto.id, commentId = dto.commentId;
            return http.get("".concat(getArticleUri(baseUrl, id), "/comments/").concat(commentId, "/replies"));
        },
        setArticleCommentReplyContent: function (dto) {
            var id = dto.id, commentId = dto.commentId, commentReplyId = dto.commentReplyId, content = dto.content;
            return http.put("".concat(getArticleUri(baseUrl, id), "/comments/").concat(commentId, "/replies/").concat(commentReplyId), { content: content });
        },
        deleteArticleCommentReply: function (dto) {
            var id = dto.id, commentId = dto.commentId, commentReplyId = dto.commentReplyId;
            return http.delete("".concat(getArticleUri(baseUrl, id), "/comments/").concat(commentId, "/replies/").concat(commentReplyId));
        },
        saveArticleComment: function (dto) { return http.put("".concat(getArticleUri(baseUrl, dto.id), "/comments"), dto); },
        voteOnIssueOrFeature: function (dto) { return http.post("".concat(getArticleUri(baseUrl, dto.id), "/vote"), dto); },
        unvoteOnIssueOrFeature: function (dto) { return http.delete("".concat(getArticleUri(baseUrl, dto.id), "/vote?locale=").concat(dto.locale)); },
        sendFeedback: function (dto) { return http.post("".concat(getArticleUri(baseUrl, dto.id), "/helpful"), dto); },
        sendAdditionalFeedback: function (dto) { return http.post("".concat(getArticleUri(baseUrl, dto.article_id), "/feedback"), dto); },
        validateUrls: function (dto) { return http.post("".concat(baseUrl, "/articles/validateUrls"), dto); },
        // bulk actions
        deleteArticles: function (dto) { return http.post("".concat(baseUrl, "/articles/delete"), dto); },
        unpublishArticles: function (dto) { return http.post("".concat(baseUrl, "/articles/unpublish"), dto); },
        publishArticles: function (dto) { return http.post("".concat(baseUrl, "/articles/publish"), dto); },
        moveArticlesToCategory: function (dto) { return http.post("".concat(baseUrl, "/articles/move"), dto); },
        editArticlesLabels: function (dto) { return http.put("".concat(baseUrl, "/articles/labels"), dto); },
        addArticlesTask: function (dto) { return http.post("".concat(baseUrl, "/articles/tasks"), dto); },
        addArticlesTranslations: function (dto) { return http.post("".concat(baseUrl, "/articles/translations"), dto); },
        isFollowingArticle: function (dto) { return http.get("".concat(baseUrl, "/articles/").concat(dto.id, "/follow?locale=").concat(dto.locale)); },
        followArticle: function (dto) { return http.post("".concat(baseUrl, "/articles/").concat(dto.id, "/follow"), dto); },
        unfollowArticle: function (dto) { return http.delete("".concat(baseUrl, "/articles/").concat(dto.id, "/follow?locale=").concat(dto.locale)); },
        getFollowedArticles: function (dto) { return http.get("".concat(baseUrl, "/articles/followed?userId=").concat(dto.userId, "&page=").concat(dto.page, "&pageSize=").concat(dto.pageSize, "&locale=").concat(dto.locale)); },
        updateArticleCollaborators: function (dto) { return http.put("".concat(baseUrl, "/articles/").concat(dto.id, "/collaborators"), dto); },
        completeArticlesTask: function (dto) { return http.put("".concat(baseUrl, "/articles/tasks"), dto); },
    };
    return articlesApi;
};
//# sourceMappingURL=index.js.map